var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.698,
    height: 53.327,
    viewBox: "0 0 33.698 53.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11229",
    "data-name": "Rectangle 11229",
    width: 33.698,
    height: 53.327,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3031",
    "data-name": "Group 3031",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    d: "M18.74,59.518A9.438,9.438,0,0,1,16,59.112l-.938-.284-.937.284a9.439,9.439,0,0,1-2.738.406,9.306,9.306,0,0,1-4.057-.932,17.071,17.071,0,0,1-4.08-2.745A12.423,12.423,0,0,1,.824,40.9c.067-.128.137-.256.206-.38A21,21,0,0,1,4.269,36.24a6.916,6.916,0,0,0,2.088-5.03,14.153,14.153,0,0,1,2.006-7.8,7.62,7.62,0,0,1,6.7-3.587,7.62,7.62,0,0,1,6.7,3.587,14.153,14.153,0,0,1,2.006,7.8,6.916,6.916,0,0,0,2.088,5.031,21,21,0,0,1,3.24,4.277c.068.122.138.251.205.379a12.424,12.424,0,0,1-2.428,14.946A17.051,17.051,0,0,1,22.8,58.586,9.306,9.306,0,0,1,18.74,59.518Zm-3.676-2.871a1.066,1.066,0,0,1,.309.046l1.247.378a7.307,7.307,0,0,0,2.119.315,7.162,7.162,0,0,0,3.122-.716,14.922,14.922,0,0,0,3.571-2.4,10.29,10.29,0,0,0,1.985-12.382c-.06-.114-.121-.227-.182-.336a18.957,18.957,0,0,0-2.924-3.846A9.747,9.747,0,0,1,22.024,33.9a8.406,8.406,0,0,1-.384-2.756,11.6,11.6,0,0,0-.072-1.853c-.357-2.741-1.676-7.341-6.5-7.341s-6.147,4.6-6.5,7.342a11.6,11.6,0,0,0-.072,1.852A8.406,8.406,0,0,1,8.1,33.9a9.747,9.747,0,0,1-2.288,3.8,18.954,18.954,0,0,0-2.923,3.844c-.062.111-.123.224-.183.337A10.29,10.29,0,0,0,4.695,54.271a14.943,14.943,0,0,0,3.571,2.4,7.162,7.162,0,0,0,3.122.716,7.307,7.307,0,0,0,2.12-.315l1.246-.378A1.066,1.066,0,0,1,15.064,56.647Z",
    transform: "translate(0.189 -5.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M15.009,17.673a1.066,1.066,0,0,1-1.05-.885,12.964,12.964,0,0,0-2.34-5.46l-.028-.036a5.444,5.444,0,0,0-3.016-2A5.981,5.981,0,0,0,6.914,9.06a1.066,1.066,0,0,1-.868-.373,3.125,3.125,0,0,1-.7-2.578,3.889,3.889,0,0,1,.4-1.219A1.066,1.066,0,0,1,6.8,4.346a17.3,17.3,0,0,1,5.1,1.529,5.137,5.137,0,0,0,3.035.536,5.715,5.715,0,0,0,1.706-.558,9.858,9.858,0,0,1,5.33-1.108,15.707,15.707,0,0,1,8.95,3.842,1.066,1.066,0,0,1-1.4,1.61,13.586,13.586,0,0,0-7.741-3.328,7.734,7.734,0,0,0-4.173.884,7.843,7.843,0,0,1-2.342.764,7.251,7.251,0,0,1-4.3-.726A15.268,15.268,0,0,0,7.439,6.616a1.133,1.133,0,0,0,.039.328A7.936,7.936,0,0,1,13.289,10a15.114,15.114,0,0,1,2.773,6.426,1.067,1.067,0,0,1-1.052,1.247Z",
    transform: "translate(-1.534 -1.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M31.652,14.769a8.681,8.681,0,0,1-3.9-.866,9.36,9.36,0,0,1-5.213-5.72,7.365,7.365,0,0,1-.227-3.4l2.085.448,0-.008a5.49,5.49,0,0,0,.215,2.452A7.366,7.366,0,0,0,28.715,12l.047.024a5.945,5.945,0,0,0,1.681.515,7.781,7.781,0,0,0,4.157-.477l.007,0c.034-.013.847-.325,1.841-.615a15.447,15.447,0,0,1,1.608-.389,7.218,7.218,0,0,1-.074-1.313,7.989,7.989,0,0,0-.225-2.6A7.008,7.008,0,0,0,33.05,1.916a9.072,9.072,0,0,0-3.586-.391l-.017,0a7.286,7.286,0,0,0-2.4.686A1.066,1.066,0,0,1,26.1.307a9.4,9.4,0,0,1,3.088-.9,11.131,11.131,0,0,1,4.438.449,9.1,9.1,0,0,1,6.191,6.726,9.966,9.966,0,0,1,.3,3.19,3.1,3.1,0,0,0,.3,1.679,1.066,1.066,0,0,1-1.053,1.626,12.79,12.79,0,0,0-3.99.965A10.152,10.152,0,0,1,31.652,14.769Z",
    transform: "translate(-6.424 0.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    d: "M21.094,19.777a1.067,1.067,0,0,1-1.049-.882,16.406,16.406,0,0,0-1.782-5.061,1.066,1.066,0,1,1,1.828-1.1,18.449,18.449,0,0,1,2.055,5.791,1.067,1.067,0,0,1-1.051,1.251Z",
    transform: "translate(-5.237 -3.533)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPears);
export default __webpack_public_path__ + "static/media/pears.b95c801471f174537c32c786b5659559.svg";
export { ForwardRef as ReactComponent };